import { iconoClassnameTipoPedido, iconoColorTipoPedido } from "../views/PedidosProducto/enums";

export default {
    root: [{
        name: 'General',
        items: [
            // --- Viandas ---
            {
                name:  'Viandas',
                icon: 'fa fa-cutlery',
                color: '#32CD32',
                items: [

                    {
                        name: 'Pedidos',
                        url: '/pedidosviandas/',
                        icon: 'fa fa-file-text-o',
                        permission: 'cliente_viandas_pedidos_new'
                    },
                    {
                        name: 'Historial',
                        url: '/historialviandas/',
                        icon: 'fa fa-calendar',
                        permission: 'cliente_viandas_pedidos_view'
                    },
                ]
            },

            // --- Insumos ---
            {
                name: 'Insumos',
                url: '/pedidosinsumos/',
                icon: iconoClassnameTipoPedido.insumos,
                color: iconoColorTipoPedido.insumos,
                items: [
                    {
                        name: 'Pedidos',
                        url: '/pedidosinsumos/',
                        icon: 'fa fa-file-text-o',
                        permission: 'cliente_productos_pedidos_insumos_new'
                    },
                    {
                        name: 'Historial',
                        url: '/historialpedidosinsumos/',
                        icon: 'fa fa-calendar',
                        permission: 'cliente_productos_pedidos_insumos_view'
                    },
                ]
            },

            // --- Cafeteria ---
            {
                name: 'Cafetería',
                url: '/pedidoscafeteria/',
                icon: iconoClassnameTipoPedido.cafeteria,
                color: iconoColorTipoPedido.cafeteria,
                // Sin permission: NavList recursa a los hijos, asi que el grupo
                // se muestra solo si alguno de los dos es accesible.
                items: [
                    {
                        name: 'Pedidos',
                        url: '/pedidoscafeteria/',
                        icon: 'fa fa-file-text-o',
                        permission: 'cliente_productos_pedidos_cafeteria_new'
                    },
                    {
                        name: 'Historial',
                        url: '/historialpedidoscafeteria/',
                        icon: 'fa fa-calendar',
                        permission: 'cliente_productos_pedidos_cafeteria_view'
                    },
                ]
            },

            // --- Refrigerio ---
            {
                name: 'Refrigerios',
                url: '/pedidosrefrigerios/',
                icon: iconoClassnameTipoPedido.refrigerios,
                color: iconoColorTipoPedido.refrigerios,
                // Sin permission: ver el comentario en Cafeteria.
                items: [
                    {
                        name: 'Pedidos',
                        url: '/pedidosrefrigerios/',
                        icon: 'fa fa-file-text-o',
                        permission: 'cliente_productos_pedidos_refrigerios_new'
                    },
                    {
                        name: 'Historial',
                        url: '/historialpedidosrefrigerio/',
                        icon: 'fa fa-calendar',
                        permission: 'cliente_productos_pedidos_refrigerios_view'
                    },
                ]
            },
        ] }
    ]
};



// WEBPACK FOOTER //
// ./src/components/Menues.js